import React from "react";
import { CardMedia } from "@mui/material";
import {
  CardMediaWrapper,
  ServiceCardContainer,
  StyledCard,
  TitleOverlay,
} from "./ServiceCard.styled";

interface ServiceCardProps {
  title: string;
  imageUrl: string;
  href: string;
  maxWidth?: string;
}
const ServiceCard: React.FC<ServiceCardProps> = ({
  title,
  imageUrl,
  href,
  maxWidth,
}) => {
  return (
    <ServiceCardContainer to={href}>
      <StyledCard>
        <CardMediaWrapper>
          <CardMedia
            component="img"
            image={imageUrl}
            alt={title}
            sx={{
              position: "absolute",
              zIndex: 0,
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />
          <TitleOverlay variant="h5" sx={{ maxWidth: maxWidth }}>
            {title}
          </TitleOverlay>
        </CardMediaWrapper>
      </StyledCard>
    </ServiceCardContainer>
  );
};

export default ServiceCard;
